// extracted by mini-css-extract-plugin
export default {"mainLayout":"main-layout_mainLayout__KkBhy","footer":"main-layout_footer__jSlUy","rotate":"main-layout_rotate__I7aVI"};